export default __webpack_public_path__ + "static/media/randomcolor.d673e062.svg";